module.exports = __webpack_public_path__ + "static/media/play.9d65ad47.svg";